exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#duplicateDeliverableDetailModal___BV_modal_content_ {\n  padding: 16px;\n}\n.edit-deliverable-modal-pop .modal-dialog {\n  max-width: 90vw;\n}\n.edit-deliverable-modal-pop .modal-body {\n  padding: 24px 28px;\n}\n.dup-preview-description {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  background: #fafafa;\n}\n", ""]);

// exports
